import { Component, Input  } from '@angular/core';

@Component({
  selector: 'app-chip-custom',
  templateUrl: './chip-custom.component.html',
  styleUrls: ['./chip-custom.component.css']
})
export class ChipCustomComponent {

  @Input() icon: string = '';
  @Input() text: string = '';
  @Input() backgroundColor: string = '#E0E0E0';  // Gris por defecto de Angular Material
  @Input() textColor: string = 'black';
  @Input() titleCase: boolean = true;


}
